
const initialState = {
    orderType: [
        { id: 1, name: "Internal" },
        { id: 2, name: "External" }
    ]
};

export default function dropDown(state = initialState, { type, payload }) {
    switch (type) {
        case "SET_DD_DEPT":
            return { ...state, department_id: payload };
        case "SET_DD_AREA":
            return { ...state, area_id: payload };
        case "SET_DD_FACILITY":
            return { ...state, facility_id: payload };
        case "SET_DD_EQU":
            return { ...state, equipment_id: payload };
        case "SET_DD_SUB_EQU":
            return { ...state, sub_equipment_id: payload };
        case "SET_DD_DEVICE":
            return { ...state, device_id: payload };
        case "SET_DD_EMP":
            return { ...state, employee_id: payload };
        case "SET_DD_JOB_N":
            return { ...state, job_nature_id: payload };
        case "SET_DD_JOB_P":
            return { ...state, job_priority_id: payload };
        case "SET_DD_WORK_PERMIT":
            return { ...state, work_permit_id: payload };
        case "SET_DD_VENDOR":
            return { ...state, vendor_id: payload };
        case "SET_DD_TASK":
            return { ...state, task_id: payload };
        case "SET_DD_TAG":
            return { ...state, tag: payload };
        case "SET_DD_JOBSTATUS":
            return { ...state, job_status: payload };
        case "SET_DD_WORKCENTER":
            return { ...state, work_center: payload };
        case "SET_DD_ORDER_TYPE":
            return { ...state, orderType: payload };
        case "SET_DD_COMPANY":
            return { ...state, comp_id: payload };
        case "SET_DD_LOCATION":
            return { ...state, loc_id: payload };
        case "SET_Equipment_Type":
            return { ...state, equipmentType: payload };
        case "SET_DD_Equipment_Tag":
            return { ...state, equipmentTag: payload };
        case "SET_DD_Equipment_Capacity":
            return { ...state, equipmentCapacity: payload };
        case "SET_DD_SubEquipTag":
            return { ...state, subEquipmentTag: payload };
        case "SET_DD_Device_Tag":
            return { ...state, deviceTag: payload };
        case "Reset_DD":
            return { ...initialState, comp_id: state.comp_id || [] };
        default:
            return state;
    }

};
